import { render, staticRenderFns } from "./brokerageList.vue?vue&type=template&id=0a280da1&scoped=true&"
import script from "./brokerageList.vue?vue&type=script&lang=js&"
export * from "./brokerageList.vue?vue&type=script&lang=js&"
import style0 from "./brokerageList.vue?vue&type=style&index=0&id=0a280da1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a280da1",
  null
  
)

export default component.exports